import { render, staticRenderFns } from "./editArticleDialog.vue?vue&type=template&id=66cc684a"
import script from "./editArticleDialog.vue?vue&type=script&lang=js"
export * from "./editArticleDialog.vue?vue&type=script&lang=js"
import style0 from "./editArticleDialog.vue?vue&type=style&index=0&id=66cc684a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports